var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.35197 0.34427C-0.117323 0.803298 -0.117324 1.54753 0.35197 2.00655L7.14982 8.65569C7.36898 8.87005 7.65172 8.98431 7.93866 8.99846C8.2664 9.01482 8.59968 8.90057 8.85 8.65573L15.6478 2.00659C16.1171 1.54756 16.1171 0.803332 15.6478 0.344304C15.1786 -0.114723 14.4177 -0.114723 13.9484 0.344304L7.99993 6.16263L2.05143 0.344271C1.58214 -0.114757 0.821264 -0.114757 0.35197 0.34427Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.311cceca7ec0434e13fa9adfb59cb77b.svg";
export { ForwardRef as ReactComponent };